import React from 'react';

const UserAuthorityFormModal = React.lazy(() => import('../components/FormModal'));
const userAuthorityModalRegistry = {
    core_userAuthorityName: UserAuthorityFormModal
};
export default userAuthorityModalRegistry;
